import Factory from '../utils/factory'
import ObjectId from 'mongo-objectid'
import Floorplan from './floorplan'
import Subcategory from './subcategory'

export default Factory({
  id: () => new ObjectId().hex,
  label: null,
  description: null,
  floorplans: [Floorplan],
  categories: [Subcategory],
  tags: [],
  conditions: {
    if: [],
    ifnot: [],
  },
})
